import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useLazyQuery, useQuery } from '@apollo/react-hooks';
import {
  isEmpty, get, first,
} from 'lodash/fp';
import { FETCH_SCHOOLS, SEARCH_SCHOOLS } from '../GraphQL/Queries';
import useCurrentUser from '../Hooks/userCurrentUser';
import SearchDialog from './SearchDialog/Index';
import SEARCH from '../Images/search.png';
import {
  SelectedSchool,
} from './Auth/Layout';
import useSortArrayByAlphabets from '../Hooks/useSortArrayByAlphabets';


const SchoolSearch = ({ selectedSchool, onSelectSchool }) => {
  const {
    currentUser,
  } = useCurrentUser(true);

  const sortedArray = useSortArrayByAlphabets();
  const [searchStringLength, setSearchStringLength] = useState(0);
  const [filteredSchools, setFilteredSchools] = useState([]);

  useQuery(
    FETCH_SCHOOLS, {
      variables: {
        tenantId: 1,
      },
      onCompleted: (data) => {
        setFilteredSchools(sortedArray(data.fetchSchools, 'name'));
      },
      skip: !currentUser,
    },
  );

  const [clickStatus, setClickStatus] = useState(false);

  const [schoolsSearch] = useLazyQuery(
    SEARCH_SCHOOLS,
    {
      onCompleted: (data) => {
        setFilteredSchools(sortedArray(data.searchSchools, 'name'));
      },
    },
  );

  const searchSchools = (e) => {
    setSearchStringLength(e.target.value.length);
    schoolsSearch({
      variables: {
        query: e.target.value,
        userId: parseInt(currentUser.id, 10),
      },
    });
  };

  const getSelectedSchool = (e) => {
    if (e.target.id !== '') {
      setClickStatus(false);
      setSearchStringLength(0);
      onSelectSchool({ id: parseInt(e.target.id, 10), name: e.target.innerText });
    }
  };

  useEffect(() => {
    if (!isEmpty(get('fetchSchoolsUsers', currentUser))) {
      setClickStatus(false);
      setSearchStringLength(0);
      onSelectSchool({
        id: parseInt(get('fetchSchool', first(currentUser.fetchSchoolsUsers)).id, 10),
        name: get('fetchSchool', first(currentUser.fetchSchoolsUsers)).name,
      });
    } else if (isEmpty(get('fetchSchoolsUsers', currentUser)) && !isEmpty(get('fetchSchools', currentUser))) {
      setClickStatus(false);
      setSearchStringLength(0);
      onSelectSchool({
        id: parseInt(get('id', first(currentUser.fetchSchools)), 10),
        name: get('name', first(currentUser.fetchSchools)),
      });
    }
  }, [currentUser, onSelectSchool]);

  return (
    <div className="col-12 mx-auto">
      <SearchDialog
        placeholder="Search"
        onChange={(e) => searchSchools(e)}
        data={filteredSchools}
        stringlength={searchStringLength}
        displayattribute="name"
        imageattatched={SEARCH}
        emptySearch={clickStatus}
        onClick={(e) => getSelectedSchool(e)}
        addSchoolSearch
        checkPermission
      />
      <SelectedSchool>
        <h5>{selectedSchool.name}</h5>
      </SelectedSchool>
    </div>
  );
};
SchoolSearch.propTypes = {
  selectedSchool: PropTypes.shape({
    id: PropTypes.number,
    name: PropTypes.string,
  }).isRequired,
  onSelectSchool: PropTypes.func.isRequired,
};

export default SchoolSearch;
